import ABackTop from './index.vue'
export default ABackTop



// WEBPACK FOOTER //
// ./src/components/main/components/a-back-top/index.js